import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle_equals",
  "use": "icon-circle_equals-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" id=\"icon-circle_equals\">\n    <circle cx=\"12.5\" cy=\"12.5\" r=\"12.5\" />\n    <path fill=\"#ffffff\" d=\"M732,1059v-3h9v3h-9Zm0-9h9v3h-9v-3Z\" transform=\"translate(-724 -1042)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol